import * as React from "react"

const MatahariUang2 = (props) => (
  <svg
    width={77}
    height={77}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M43 72.692c15.464 0 28-13.5 28-30.154 0-16.653-12.536-30.153-28-30.153s-28 13.5-28 30.153c0 16.654 12.536 30.154 28 30.154Z"
      fill="#FFE600"
    />
    <path
      d="M28.5 50.077c1.657 0 3-1.447 3-3.23 0-1.785-1.343-3.232-3-3.232s-3 1.447-3 3.231c0 1.784 1.343 3.23 3 3.23ZM46 69.462c1.657 0 3-1.447 3-3.231C49 64.447 47.657 63 46 63s-3 1.447-3 3.23c0 1.785 1.343 3.231 3 3.231Z"
      fill="#BCA11A"
      fillOpacity={0.6}
    />
    <path
      d="M41.75 35.538c.69 0 1.25-.602 1.25-1.346 0-.743-.56-1.346-1.25-1.346s-1.25.603-1.25 1.346c0 .744.56 1.346 1.25 1.346Z"
      fill="#BCA11A"
    />
    <path
      d="M42.25 5.385c.69 0 1.25-.603 1.25-1.347 0-.743-.56-1.346-1.25-1.346S41 3.295 41 4.038c0 .744.56 1.347 1.25 1.347ZM45.25 2.692c.69 0 1.25-.602 1.25-1.346C46.5.603 45.94 0 45.25 0S44 .603 44 1.346c0 .744.56 1.346 1.25 1.346ZM45.25 8.077c.69 0 1.25-.603 1.25-1.346 0-.744-.56-1.346-1.25-1.346S44 5.987 44 6.73c0 .743.56 1.346 1.25 1.346ZM31.75 25.308c.69 0 1.25-.603 1.25-1.346 0-.744-.56-1.347-1.25-1.347s-1.25.603-1.25 1.347c0 .743.56 1.346 1.25 1.346Z"
      fill="#E57E1F"
    />
    <path
      d="M55.5 35.538c1.657 0 3-1.446 3-3.23 0-1.785-1.343-3.231-3-3.231s-3 1.446-3 3.23c0 1.785 1.343 3.231 3 3.231Z"
      fill="#E67E1F"
    />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={3}
      y={27}
      width={23}
      height={28}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.785 49.526c5.46-2.706 7.893-9.562 5.436-15.313-2.458-5.752-8.876-8.221-14.336-5.515-5.46 2.705-7.893 9.561-5.435 15.313 1.1 2.573 2.992 4.49 5.236 5.579l.336 3.712c.062.697.878.965 1.317.433l2.568-3.112.002-.003c1.626.04 3.292-.308 4.876-1.094Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.785 49.526c5.46-2.706 7.893-9.562 5.436-15.313-2.458-5.752-8.876-8.221-14.336-5.515-5.46 2.705-7.893 9.561-5.435 15.313 1.1 2.573 2.992 4.49 5.236 5.579l.336 3.712c.062.697.878.965 1.317.433l2.568-3.112.002-.003c1.626.04 3.292-.309 4.876-1.094Z"
        fill="#F2C94C"
      />
      <path
        d="m9.686 49.59.753-.09-.041-.452-.388-.189-.324.731Zm.335 3.712-.752.09.752-.09Zm1.318.433.565.523-.565-.523Zm2.568-3.112.565.523-.565-.523Zm.002-.003.03-.802-.36-.009-.237.29.567.521Zm9.623-16.066c2.286 5.351.022 11.73-5.057 14.246l.62 1.452c5.84-2.894 8.444-10.228 5.815-16.38l-1.378.682Zm-13.336-5.13c5.079-2.517 11.05-.22 13.336 5.13l1.378-.683c-2.629-6.152-9.495-8.794-15.335-5.9l.62 1.453ZM5.139 43.669c-2.286-5.35-.022-11.728 5.057-14.245l-.62-1.452C3.734 30.866 1.131 38.2 3.76 44.352l1.378-.683Zm4.871 5.19c-2.088-1.014-3.848-2.795-4.87-5.19l-1.38.683c1.177 2.752 3.202 4.803 5.603 5.969l.647-1.462Zm.764 4.353-.335-3.712-1.505.18.335 3.712 1.505-.18Zm0 0-1.505.18c.126 1.393 1.758 1.929 2.635.866l-1.13-1.046Zm2.568-3.112-2.568 3.112 1.13 1.046 2.568-3.112-1.13-1.046Zm0 0 1.13 1.046.003-.004v-.001L13.343 50.1Zm5.133-1.3a9.642 9.642 0 0 1-4.536 1.018l-.06 1.605c1.74.043 3.523-.331 5.217-1.17l-.62-1.453Z"
        fill="#F9A33D"
      />
      <path
        d="M17.518 46.56c3.904-1.936 5.645-6.838 3.887-10.952-1.758-4.113-6.348-5.879-10.252-3.944C7.25 33.6 5.508 38.502 7.266 42.615c1.758 4.113 6.348 5.88 10.252 3.944Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.546 40.332c.305.825-.08 1.767-.862 2.105-.782.338-1.663-.056-1.968-.88l-.704.304c.457 1.234 1.776 1.824 2.947 1.318 1.17-.506 1.748-1.917 1.29-3.151a2.214 2.214 0 0 0-.864-1.077c-.393-.26-.921-.449-1.625-.495l-.017-.081a4.236 4.236 0 0 1-.328.07c-.064 0-.13 0-.197.003v.025c-1.323.155-2.04-.493-2.225-.79-.458-.737-.26-1.74.443-2.239a1.455 1.455 0 0 1 2.103.433l.633-.45c-.687-1.104-2.096-1.394-3.149-.647-1.052.747-1.35 2.248-.663 3.353.355.571 1.405 1.379 3.098 1.114.737.01 1.213.183 1.519.386.335.223.494.5.569.7Z"
        fill="#F9A33D"
      />
      <path
        d="m12.11 33.905-.494.245.445 1.04.495-.244-.445-1.041ZM16.387 42.512l-.494.245.445 1.041.494-.245-.445-1.041Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={72}
      y={40}
      width={4}
      height={6}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.916 44.379c.852-.423 1.236-1.484.856-2.371-.379-.888-1.377-1.264-2.229-.842-.852.422-1.236 1.484-.857 2.371.17.397.463.692.813.859l.05.573a.115.115 0 0 0 .204.066l.403-.483c.253.005.512-.05.76-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.916 44.379c.852-.423 1.236-1.484.856-2.371-.379-.888-1.377-1.264-2.229-.842-.852.422-1.236 1.484-.857 2.371.17.397.463.692.813.859l.05.573a.115.115 0 0 0 .204.066l.403-.483c.253.005.512-.05.76-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m73.499 44.395.117-.014-.007-.07-.06-.029-.05.114Zm.05.574-.118.014.118-.014Zm.204.066.088.08-.088-.08Zm.403-.483.087.08-.087-.08Zm0 0 .005-.124-.056-.002-.038.046.089.08Zm1.509-2.491c.353.825-.004 1.813-.797 2.206l.096.224c.912-.452 1.322-1.588.916-2.537l-.215.107Zm-2.074-.783c.793-.393 1.722-.042 2.074.783l.215-.107c-.405-.949-1.473-1.352-2.384-.9l.095.224Zm-.797 2.206c-.352-.826.004-1.813.797-2.206l-.095-.224c-.912.452-1.322 1.587-.917 2.536l.215-.106Zm.755.798a1.55 1.55 0 0 1-.755-.798l-.215.106c.181.425.496.74.869.919l.102-.227Zm.116.673-.049-.574-.235.029.05.574.234-.03Zm0 0-.234.029a.23.23 0 0 0 .41.131l-.175-.16Zm.402-.483-.401.483.175.16.402-.483-.175-.16Zm0 0 .176.16-.175-.16Zm.801-.205c-.23.114-.471.165-.707.16l-.01.249c.27.005.549-.054.813-.185l-.096-.224Z"
        fill="#F9A33D"
      />
      <path
        d="M74.72 43.921c.61-.302.885-1.061.613-1.696a1.16 1.16 0 0 0-1.594-.602c-.61.303-.884 1.062-.613 1.696a1.16 1.16 0 0 0 1.594.602Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.573 42.96a.26.26 0 0 1-.135.325.228.228 0 0 1-.306-.134l-.11.047c.07.19.275.28.458.202a.389.389 0 0 0 .203-.488.34.34 0 0 0-.134-.166.51.51 0 0 0-.253-.075l-.003-.013a.67.67 0 0 1-.05.011h-.031v.005c-.207.025-.318-.075-.347-.12a.26.26 0 0 1 .071-.347.227.227 0 0 1 .327.065l.099-.07a.34.34 0 0 0-.49-.098.391.391 0 0 0-.106.52c.055.087.218.211.483.17.115 0 .189.027.236.058a.221.221 0 0 1 .088.107Z"
        fill="#F9A33D"
      />
      <path
        d="m73.886 41.97-.077.037.069.161.077-.038-.069-.16ZM74.547 43.296l-.077.039.069.16.076-.038-.068-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="c"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={68}
      y={45}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.416 49.294c.852-.422 1.236-1.484.856-2.37-.379-.888-1.377-1.265-2.229-.843-.852.423-1.236 1.484-.857 2.371.17.398.463.692.813.859l.05.574a.115.115 0 0 0 .204.066l.403-.483c.253.004.512-.051.76-.174Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.416 49.294c.852-.422 1.236-1.484.856-2.37-.379-.888-1.377-1.265-2.229-.843-.852.423-1.236 1.484-.857 2.372.17.396.463.691.813.858l.05.574a.115.115 0 0 0 .204.066l.403-.483c.253.004.512-.051.76-.174Z"
        fill="#F2C94C"
      />
      <path
        d="m68.999 49.311.117-.014-.007-.07-.06-.03-.05.114Zm.05.574-.118.014.118-.014Zm.204.066.088.08-.088-.08Zm.403-.483.087.08-.087-.08Zm0 0 .005-.125-.056-.001-.038.045.089.08Zm1.509-2.492c.353.826-.004 1.813-.797 2.206l.096.224c.912-.451 1.322-1.587.916-2.536l-.215.106Zm-2.074-.783c.793-.392 1.722-.042 2.074.783l.215-.106c-.405-.95-1.473-1.352-2.384-.9l.095.223Zm-.797 2.206c-.352-.825.004-1.813.797-2.206l-.095-.224c-.912.452-1.322 1.588-.917 2.537l.215-.107Zm.755.799a1.55 1.55 0 0 1-.755-.799l-.215.107c.181.424.496.74.869.918l.102-.226Zm.116.672-.049-.573-.235.029.05.573.234-.029Zm0 0-.234.029a.23.23 0 0 0 .41.132l-.175-.16Zm.402-.483-.401.483.175.16.402-.482-.175-.16Zm0 0 .176.16-.175-.16Zm.801-.205c-.23.114-.471.166-.707.161l-.01.248c.27.005.549-.054.813-.185l-.096-.224Z"
        fill="#F9A33D"
      />
      <path
        d="M70.22 48.837c.61-.302.885-1.062.613-1.696a1.16 1.16 0 0 0-1.594-.602c-.61.302-.884 1.061-.613 1.696.271.634.985.904 1.594.602Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.073 47.875a.26.26 0 0 1-.135.326.228.228 0 0 1-.306-.135l-.11.048c.07.19.275.28.458.201a.389.389 0 0 0 .203-.488.339.339 0 0 0-.134-.166.51.51 0 0 0-.253-.075l-.003-.012a.672.672 0 0 1-.05.01l-.031.001v.004c-.207.025-.318-.074-.347-.12a.26.26 0 0 1 .071-.347.227.227 0 0 1 .327.066l.099-.07a.34.34 0 0 0-.49-.098.391.391 0 0 0-.106.519c.055.088.218.212.483.17.115 0 .189.027.236.058a.22.22 0 0 1 .088.108Z"
        fill="#F9A33D"
      />
      <path
        d="m69.386 46.885-.077.038.069.16.077-.038-.069-.16ZM70.047 48.212l-.077.038.069.16.076-.037-.068-.161Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="d"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={72}
      y={45}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.916 48.756c.852-.422 1.236-1.484.856-2.371-.379-.888-1.377-1.264-2.229-.842-.852.422-1.236 1.484-.857 2.371.17.397.463.692.813.858l.05.574a.115.115 0 0 0 .204.066l.403-.483c.253.005.512-.05.76-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#d)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.916 48.756c.852-.422 1.236-1.484.856-2.371-.379-.888-1.377-1.264-2.229-.842-.852.422-1.236 1.484-.857 2.371.17.397.463.692.813.859l.05.573a.115.115 0 0 0 .204.066l.403-.483c.253.005.512-.05.76-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m73.499 48.773.117-.015-.007-.07-.06-.029-.05.114Zm.05.573-.118.015.118-.015Zm.204.066.088.08-.088-.08Zm.403-.483.087.08-.087-.08Zm0 0 .005-.124-.056-.002-.038.046.089.08Zm1.509-2.491c.353.825-.004 1.813-.797 2.206l.096.224c.912-.452 1.322-1.588.916-2.537l-.215.107Zm-2.074-.783c.793-.393 1.722-.042 2.074.783l.215-.107c-.405-.949-1.473-1.352-2.384-.9l.095.224Zm-.797 2.206c-.352-.826.004-1.813.797-2.206l-.095-.224c-.912.452-1.322 1.587-.917 2.536l.215-.106Zm.755.798a1.55 1.55 0 0 1-.755-.798l-.215.106c.181.425.496.74.869.919l.102-.227Zm.116.673-.049-.574-.235.029.05.574.234-.03Zm0 0-.234.029a.23.23 0 0 0 .41.132l-.175-.161Zm.402-.483-.401.483.175.16.402-.482-.175-.161Zm0 0 .176.16-.175-.16Zm.801-.205c-.23.114-.471.165-.707.16l-.01.249a1.75 1.75 0 0 0 .813-.185l-.096-.224Z"
        fill="#F9A33D"
      />
      <path
        d="M74.72 48.298c.61-.302.885-1.061.613-1.696a1.16 1.16 0 0 0-1.594-.601c-.61.302-.884 1.06-.613 1.695a1.16 1.16 0 0 0 1.594.602Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.573 47.336a.26.26 0 0 1-.135.326.228.228 0 0 1-.306-.134l-.11.047c.07.19.275.281.458.202a.389.389 0 0 0 .203-.488.338.338 0 0 0-.134-.166.509.509 0 0 0-.253-.075l-.003-.013a.67.67 0 0 1-.05.011h-.031v.005c-.207.025-.318-.075-.347-.12a.261.261 0 0 1 .071-.347.227.227 0 0 1 .327.065l.099-.07a.34.34 0 0 0-.49-.098.391.391 0 0 0-.106.52c.055.087.218.211.483.17.115 0 .189.027.236.058a.22.22 0 0 1 .088.107Z"
        fill="#F9A33D"
      />
      <path
        d="m73.886 46.346-.077.038.069.161.077-.038-.069-.16ZM74.547 47.673l-.077.039.069.16.076-.038-.068-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={68}
      y={41}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.416 44.448c.852-.422 1.236-1.484.856-2.371-.379-.887-1.377-1.264-2.229-.842-.852.423-1.236 1.484-.857 2.371.17.397.463.692.813.859l.05.573a.115.115 0 0 0 .204.066l.403-.483c.253.005.512-.05.76-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#e)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.416 44.448c.852-.422 1.236-1.484.856-2.371-.379-.887-1.377-1.264-2.229-.842-.852.423-1.236 1.484-.857 2.371.17.397.463.692.813.859l.05.573a.115.115 0 0 0 .204.066l.403-.483c.253.005.512-.05.76-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m68.999 44.465.117-.015-.007-.07-.06-.028-.05.113Zm.05.573-.118.015.118-.014Zm.204.066.088.08-.088-.08Zm.403-.483.087.08-.087-.08Zm0 0 .005-.124-.056-.001-.038.045.089.08Zm1.509-2.49c.353.825-.004 1.812-.797 2.205l.096.224c.912-.452 1.322-1.587.916-2.536l-.215.106Zm-2.074-.784c.793-.393 1.722-.042 2.074.783l.215-.106c-.405-.95-1.473-1.352-2.384-.9l.095.223Zm-.797 2.206c-.352-.825.004-1.813.797-2.206l-.095-.224c-.912.452-1.322 1.588-.917 2.537l.215-.107Zm.755.799a1.55 1.55 0 0 1-.755-.799l-.215.107c.181.424.496.74.869.918l.102-.226Zm.116.672-.049-.574-.235.03.05.573.234-.029Zm0 0-.234.029a.23.23 0 0 0 .41.132l-.175-.161Zm.402-.483-.401.483.175.16.402-.482-.175-.161Zm0 0 .176.16-.175-.16Zm.801-.205c-.23.114-.471.166-.707.161l-.01.248c.27.005.549-.054.813-.185l-.096-.224Z"
        fill="#F9A33D"
      />
      <path
        d="M70.22 43.99c.61-.302.885-1.06.613-1.695a1.16 1.16 0 0 0-1.594-.602c-.61.302-.884 1.061-.613 1.696a1.16 1.16 0 0 0 1.594.602Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.073 43.029a.26.26 0 0 1-.135.326.227.227 0 0 1-.306-.135l-.11.048c.07.19.275.28.458.201a.389.389 0 0 0 .203-.488.338.338 0 0 0-.134-.166.51.51 0 0 0-.253-.075l-.003-.013a.67.67 0 0 1-.05.012h-.031v.004c-.207.025-.318-.075-.347-.12a.26.26 0 0 1 .071-.347.227.227 0 0 1 .327.066l.099-.07a.34.34 0 0 0-.49-.098.391.391 0 0 0-.106.519c.055.088.218.212.483.17.115 0 .189.027.236.058a.221.221 0 0 1 .088.108Z"
        fill="#F9A33D"
      />
      <path
        d="m69.386 42.038-.077.039.069.16.077-.038-.069-.16ZM70.047 43.366l-.077.038.069.16.076-.038-.068-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="f"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={22}
      y={69}
      width={3}
      height={4}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.246 71.725c.483-.24.7-.841.486-1.344a.918.918 0 0 0-1.264-.477c-.482.24-.7.841-.485 1.344a.943.943 0 0 0 .46.486l.028.325c.006.06.078.084.117.037l.227-.273a.928.928 0 0 0 .431-.098Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#f)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.245 71.725c.483-.24.7-.841.486-1.344a.918.918 0 0 0-1.263-.477c-.483.24-.7.841-.486 1.344a.942.942 0 0 0 .46.486l.029.325c.005.06.077.084.116.037l.227-.273a.927.927 0 0 0 .431-.098Z"
        fill="#F2C94C"
      />
      <path
        d="m23.443 71.734.067-.008-.004-.04-.034-.016-.029.064Zm.028.325-.066.008.066-.008Zm.117.037.05.046-.05-.046Zm.227-.273.05.045-.05-.045Zm0 0 .003-.07-.031-.001-.021.025.05.046Zm.856-1.412a.979.979 0 0 1-.452 1.25l.054.127c.517-.256.75-.9.52-1.437l-.122.06Zm-1.175-.443a.854.854 0 0 1 1.175.443l.122-.06a.982.982 0 0 0-1.352-.51l.055.127Zm-.452 1.25a.979.979 0 0 1 .452-1.25l-.055-.127c-.516.256-.748.9-.519 1.437l.122-.06Zm.428.452a.876.876 0 0 1-.428-.453l-.122.06c.103.241.281.42.492.52l.058-.127Zm.066.381-.028-.325-.133.016.028.325.133-.016Zm0 0-.133.016a.13.13 0 0 0 .232.075l-.1-.091Zm.228-.274-.228.274.1.091.227-.274-.1-.091Zm0 0 .1.091-.1-.091Zm.453-.116a.862.862 0 0 1-.4.091l-.006.14a.995.995 0 0 0 .46-.104l-.054-.127Z"
        fill="#F9A33D"
      />
      <path
        d="M24.136 71.465c.345-.171.5-.6.347-.96a.656.656 0 0 0-.904-.341c-.345.17-.5.6-.347.96.154.36.558.512.904.341Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.052 70.92a.147.147 0 0 1-.077.185.13.13 0 0 1-.173-.076l-.062.027c.04.108.156.159.26.114a.22.22 0 0 0 .114-.277.19.19 0 0 0-.076-.093.29.29 0 0 0-.143-.043l-.001-.008a.349.349 0 0 1-.03.007h-.017v.003c-.117.014-.18-.043-.196-.069a.148.148 0 0 1 .04-.196.129.129 0 0 1 .186.037l.056-.04a.192.192 0 0 0-.278-.055.221.221 0 0 0-.06.294c.031.05.124.12.273.096.065 0 .107.016.134.033.03.02.044.044.05.061Z"
        fill="#F9A33D"
      />
      <path
        d="m23.663 70.36-.044.021.04.091.043-.022-.039-.09ZM24.037 71.111l-.043.022.038.09.044-.02-.039-.092Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="g"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={22}
      y={73}
      width={3}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.436 74.977c.483-.24.7-.842.485-1.344a.918.918 0 0 0-1.263-.477c-.483.24-.7.841-.486 1.343a.946.946 0 0 0 .46.487l.029.325c.005.06.077.084.116.037l.228-.273a.929.929 0 0 0 .43-.099Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#g)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.435 74.976c.483-.24.7-.84.485-1.343a.918.918 0 0 0-1.263-.477c-.483.24-.7.841-.485 1.343a.946.946 0 0 0 .46.487l.028.325c.005.06.077.084.116.037l.228-.274a.928.928 0 0 0 .43-.098Z"
        fill="#F2C94C"
      />
      <path
        d="m22.633 74.986.066-.008-.004-.04-.034-.017-.029.065Zm.028.325-.067.008.067-.008Zm.116.037.05.046-.05-.046Zm.228-.274.05.046-.05-.046Zm0 0 .003-.07h-.032l-.021.025.05.045Zm.855-1.41a.979.979 0 0 1-.451 1.249l.054.127c.516-.256.749-.9.519-1.437l-.122.06Zm-1.175-.445a.855.855 0 0 1 1.175.444l.122-.06a.982.982 0 0 0-1.351-.51l.054.126Zm-.452 1.25a.979.979 0 0 1 .452-1.25l-.054-.126c-.517.256-.75.9-.52 1.436l.122-.06Zm.428.453a.876.876 0 0 1-.428-.453l-.122.06c.103.241.281.42.493.521l.057-.129Zm.066.38-.028-.325-.133.017.028.325.133-.016Zm0 0-.133.017a.13.13 0 0 0 .232.075l-.099-.091Zm.228-.273-.228.274.1.09.227-.273-.099-.09Zm0 0 .1.091-.1-.09Zm.454-.116a.861.861 0 0 1-.401.09l-.006.141a.987.987 0 0 0 .46-.104l-.053-.127Z"
        fill="#F9A33D"
      />
      <path
        d="M23.325 74.717c.345-.17.5-.601.347-.96a.657.657 0 0 0-.903-.342c-.346.172-.501.601-.347.961.153.36.558.512.903.34Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.241 74.172a.147.147 0 0 1-.076.185.129.129 0 0 1-.174-.076l-.062.027c.04.107.156.158.26.114a.22.22 0 0 0 .115-.277.19.19 0 0 0-.076-.094.288.288 0 0 0-.144-.042L23.083 74a.32.32 0 0 1-.029.007h-.017v.002c-.117.014-.18-.042-.197-.068a.147.147 0 0 1 .04-.196.128.128 0 0 1 .186.037l.056-.04a.193.193 0 0 0-.278-.055.221.221 0 0 0-.06.294c.032.05.124.12.274.096.065 0 .107.015.134.033.029.02.043.044.05.061Z"
        fill="#F9A33D"
      />
      <path
        d="m22.852 73.61-.043.023.038.091.044-.022-.039-.091ZM23.227 74.363l-.044.022.039.09.043-.02-.038-.092Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={24}
      y={72}
      width={3}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.03 74.278c.483-.24.7-.841.485-1.343a.918.918 0 0 0-1.263-.477c-.483.24-.7.84-.485 1.343a.943.943 0 0 0 .46.486l.028.325c.005.061.077.085.116.038l.228-.274a.928.928 0 0 0 .431-.098Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#h)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.03 74.278c.482-.24.7-.841.485-1.343a.918.918 0 0 0-1.264-.477c-.483.24-.7.84-.485 1.343a.943.943 0 0 0 .46.486l.028.325c.005.061.077.085.116.038l.228-.274a.928.928 0 0 0 .431-.098Z"
        fill="#F2C94C"
      />
      <path
        d="m25.227 74.287.066-.008-.003-.04-.034-.016-.03.064Zm.028.325-.066.009.066-.008Zm.116.038.05.045-.05-.045Zm.228-.274.05.046-.05-.046Zm0 0 .003-.07-.032-.001-.02.025.05.046Zm.855-1.411a.979.979 0 0 1-.451 1.25l.054.127c.517-.257.749-.9.52-1.438l-.123.06Zm-1.175-.444a.854.854 0 0 1 1.175.444l.122-.06a.982.982 0 0 0-1.351-.511l.054.127Zm-.451 1.25a.979.979 0 0 1 .451-1.25l-.054-.127c-.517.256-.749.9-.52 1.437l.123-.06Zm.428.452a.877.877 0 0 1-.428-.452l-.122.06c.103.24.28.42.492.52l.058-.128Zm.066.381-.029-.325-.133.017.029.325.133-.017Zm0 0-.133.017a.13.13 0 0 0 .232.074l-.1-.09Zm.227-.274-.227.274.099.091.228-.273-.1-.092Zm0 0 .1.092-.1-.092Zm.454-.115a.86.86 0 0 1-.4.09l-.007.141a.995.995 0 0 0 .461-.104l-.054-.127Z"
        fill="#F9A33D"
      />
      <path
        d="M25.92 74.019c.345-.172.5-.601.346-.961a.656.656 0 0 0-.903-.34c-.345.17-.5.6-.347.96.153.359.558.512.903.34Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.836 73.474a.147.147 0 0 1-.077.184.129.129 0 0 1-.174-.076l-.062.027c.04.108.156.16.26.115a.22.22 0 0 0 .115-.277.19.19 0 0 0-.076-.094.288.288 0 0 0-.143-.043l-.002-.007a.356.356 0 0 1-.029.006l-.017.001v.002c-.117.014-.18-.042-.196-.068a.148.148 0 0 1 .04-.197.13.13 0 0 1 .185.037l.056-.039a.192.192 0 0 0-.277-.055.221.221 0 0 0-.06.294c.03.05.123.12.273.095.065.001.107.016.134.034.03.02.043.043.05.06Z"
        fill="#F9A33D"
      />
      <path
        d="m25.447 72.912-.044.023.039.09.043-.022-.038-.09ZM25.82 73.665l-.043.021.04.091.043-.021-.04-.091Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="i"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={20}
      y={70}
      width={3}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.652 72.532c.483-.24.7-.841.485-1.344a.918.918 0 0 0-1.263-.477c-.482.24-.7.841-.485 1.344a.942.942 0 0 0 .46.486l.028.325c.006.061.077.084.116.037l.228-.273a.927.927 0 0 0 .431-.098Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#i)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.651 72.532c.483-.24.7-.841.486-1.344a.918.918 0 0 0-1.264-.477c-.482.24-.7.841-.485 1.344a.943.943 0 0 0 .46.486l.028.325c.006.061.078.084.116.037l.228-.273a.928.928 0 0 0 .431-.098Z"
        fill="#F2C94C"
      />
      <path
        d="m20.849 72.542.067-.01-.004-.038-.034-.017-.029.065Zm.028.324-.066.008.066-.008Zm.116.037.05.046-.05-.046Zm.228-.273.05.046-.05-.046Zm0 0 .003-.07-.031-.001-.021.026.05.045Zm.856-1.411a.979.979 0 0 1-.452 1.25l.054.126c.517-.256.75-.9.52-1.437l-.122.06Zm-1.176-.444a.855.855 0 0 1 1.176.444l.121-.06a.982.982 0 0 0-1.35-.511l.053.127Zm-.451 1.25a.979.979 0 0 1 .451-1.25l-.054-.127c-.516.256-.749.9-.519 1.437l.122-.06Zm.428.452a.876.876 0 0 1-.428-.452l-.122.06c.103.24.28.42.492.52l.058-.128Zm.066.381-.028-.325-.133.017.028.324.133-.016Zm0 0-.133.016a.13.13 0 0 0 .232.075l-.1-.09Zm.228-.273-.228.273.099.091.228-.273-.1-.091Zm0 0 .099.09-.1-.09Zm.453-.117a.861.861 0 0 1-.4.091l-.007.14a.988.988 0 0 0 .461-.104l-.054-.127Z"
        fill="#F9A33D"
      />
      <path
        d="M21.541 72.272c.346-.17.501-.6.348-.96a.657.657 0 0 0-.904-.341c-.345.171-.5.6-.347.96.154.36.558.513.903.341Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.458 71.727a.147.147 0 0 1-.077.185.129.129 0 0 1-.173-.076l-.063.027c.04.108.157.159.26.114a.22.22 0 0 0 .115-.276.19.19 0 0 0-.076-.094.289.289 0 0 0-.143-.043l-.002-.007a.32.32 0 0 1-.029.006h-.017v.003c-.117.014-.18-.043-.196-.069a.147.147 0 0 1 .04-.195.128.128 0 0 1 .185.036l.056-.04a.192.192 0 0 0-.277-.055.221.221 0 0 0-.06.294c.031.05.123.12.273.097.065 0 .107.015.134.033.03.019.043.043.05.06Z"
        fill="#F9A33D"
      />
      <path
        d="m21.069 71.166-.044.022.039.091.044-.022-.04-.09ZM21.443 71.918l-.044.022.04.091.043-.022-.039-.09Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="j"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={6}
      y={55}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.018 58.924c.968-.48 1.404-1.687.974-2.695-.431-1.008-1.566-1.436-2.534-.956-.969.48-1.405 1.686-.974 2.694.193.451.526.787.923.976l.057.652a.13.13 0 0 0 .232.075l.457-.55c.289.006.584-.057.865-.196Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#j)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.018 58.924c.968-.48 1.404-1.687.974-2.695-.431-1.008-1.566-1.436-2.534-.956-.969.48-1.405 1.686-.974 2.694.193.451.526.787.923.976l.057.652a.13.13 0 0 0 .232.075l.457-.55c.289.006.584-.057.865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m7.407 58.943.133-.017-.007-.079-.068-.032-.058.128Zm.057.652-.134.016.134-.016Zm.232.075.1.091-.1-.091Zm.457-.55.1.092-.1-.091Zm0 0 .007-.14-.064-.002-.042.051.1.091Zm1.716-2.83c.401.938-.004 2.06-.905 2.507l.108.254c1.036-.513 1.503-1.804 1.042-2.883l-.245.122Zm-2.357-.89c.901-.447 1.956-.048 2.357.89l.245-.121c-.461-1.079-1.675-1.537-2.71-1.024l.108.255Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.255c-1.036.514-1.502 1.804-1.041 2.883l.244-.121Zm.859.908a1.762 1.762 0 0 1-.859-.908l-.244.12c.206.483.563.842.987 1.044l.116-.256Zm.132.764-.057-.653-.266.033.056.652.267-.032Zm0 0-.267.032c.022.245.31.338.466.15l-.2-.182Zm.457-.55-.457.55.199.182.457-.549-.2-.183Zm0 0 .199.183-.2-.183Zm.91-.232c-.262.13-.537.188-.804.182l-.012.282c.308.006.624-.06.924-.21l-.108-.254Z"
        fill="#F9A33D"
      />
      <path
        d="M8.796 58.404c.692-.343 1.004-1.206.696-1.928-.308-.72-1.12-1.027-1.812-.683-.693.343-1.004 1.206-.696 1.927.308.72 1.119 1.027 1.812.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.628 57.31a.295.295 0 0 1-.154.371.258.258 0 0 1-.348-.153l-.125.055c.08.216.314.318.521.228a.442.442 0 0 0 .231-.554.384.384 0 0 0-.152-.189.575.575 0 0 0-.288-.085l-.003-.015a.707.707 0 0 1-.058.013h-.035v.005c-.234.029-.36-.085-.393-.137a.296.296 0 0 1 .08-.393.258.258 0 0 1 .372.074l.113-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.062.1.247.241.547.193.13 0 .215.03.269.066a.25.25 0 0 1 .1.123Z"
        fill="#F9A33D"
      />
      <path
        d="m7.848 56.185-.088.044.078.182.088-.043-.078-.183ZM8.598 57.694l-.087.043.078.183.088-.043-.079-.183Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={61}
      width={5}
      height={6}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.392 65.447c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.436-2.534-.957-.968.48-1.404 1.687-.973 2.695.193.452.526.787.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.584-.057.865-.196Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#k)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.392 65.447c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.436-2.534-.957-.968.48-1.404 1.687-.973 2.695.193.452.526.787.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.584-.057.865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m5.78 65.466.134-.016-.007-.08-.068-.032-.058.128Zm.057.652-.133.016.133-.016Zm.233.075.1.091-.1-.091Zm.457-.55.1.092-.1-.091Zm0 0 .006-.14-.063-.002-.042.051.1.091Zm1.716-2.83c.4.938-.005 2.06-.906 2.507l.11.254c1.035-.513 1.501-1.804 1.04-2.883l-.244.122Zm-2.357-.89c.9-.447 1.956-.048 2.357.89l.245-.122c-.461-1.078-1.675-1.536-2.711-1.023l.109.255ZM4.98 64.43c-.4-.938.005-2.06.906-2.507l-.109-.255c-1.036.514-1.502 1.804-1.041 2.883l.244-.121Zm.859.907a1.762 1.762 0 0 1-.859-.907l-.244.12c.206.483.563.842.987 1.045l.116-.257Zm.132.765-.057-.653-.267.033.057.652.267-.032Zm0 0-.267.032c.021.245.31.338.466.15l-.2-.182Zm.457-.55-.457.55.199.182.457-.549-.2-.183Zm0 0 .199.183-.2-.183Zm.91-.232c-.263.13-.537.188-.805.182l-.011.282c.308.006.624-.061.924-.21l-.109-.254Z"
        fill="#F9A33D"
      />
      <path
        d="M7.17 64.927c.692-.343 1.004-1.206.696-1.927-.308-.721-1.12-1.027-1.812-.684-.693.343-1.005 1.206-.697 1.927.309.72 1.12 1.027 1.813.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.002 63.834a.295.295 0 0 1-.154.37.258.258 0 0 1-.348-.153l-.125.055c.08.216.313.318.52.228a.442.442 0 0 0 .232-.554.385.385 0 0 0-.152-.189.582.582 0 0 0-.288-.085l-.003-.014a.84.84 0 0 1-.058.012h-.035v.005c-.234.028-.36-.085-.393-.136a.297.297 0 0 1 .08-.395.257.257 0 0 1 .372.075l.112-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.063.1.248.241.548.193.13 0 .215.031.269.066.059.04.087.087.1.123Z"
        fill="#F9A33D"
      />
      <path
        d="m6.222 62.708-.088.044.078.182.088-.043-.078-.183ZM6.972 64.217l-.087.043.078.183.087-.043-.078-.183Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="l"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={9}
      y={60}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.596 64.046c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.436-2.534-.957-.968.48-1.404 1.687-.973 2.695.193.452.526.787.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.584-.057.865-.196Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#l)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.596 64.046c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.436-2.534-.957-.968.48-1.404 1.687-.973 2.695.193.452.526.787.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.584-.057.865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m10.985 64.065.133-.017-.007-.079-.069-.033-.057.13Zm.056.652-.133.016.133-.016Zm.233.075.1.091-.1-.091Zm.457-.55.1.092-.1-.091Zm0 0 .006-.14-.063-.002-.042.051.1.091Zm1.716-2.83c.4.938-.005 2.06-.906 2.507l.109.254c1.036-.513 1.502-1.804 1.041-2.883l-.244.122Zm-2.357-.89c.9-.447 1.956-.048 2.357.89l.245-.122c-.461-1.078-1.675-1.536-2.711-1.023l.109.255Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.255c-1.036.514-1.502 1.804-1.042 2.883l.245-.121Zm.859.907a1.762 1.762 0 0 1-.859-.907l-.245.12c.207.483.564.842.988 1.045l.116-.258Zm.132.765-.057-.653-.267.033.057.652.267-.032Zm0 0-.267.032c.021.245.31.337.466.15l-.2-.182Zm.457-.55-.457.55.199.182.457-.549-.2-.183Zm0 0 .199.183-.2-.183Zm.91-.232c-.263.13-.537.188-.805.182l-.011.282c.308.006.623-.061.924-.21l-.109-.254Z"
        fill="#F9A33D"
      />
      <path
        d="M12.373 63.526c.693-.343 1.005-1.206.697-1.927-.308-.722-1.12-1.027-1.812-.684-.693.343-1.005 1.206-.697 1.927.309.72 1.12 1.027 1.812.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.206 62.432a.295.295 0 0 1-.154.37.258.258 0 0 1-.348-.152l-.125.054c.08.217.313.32.52.23a.442.442 0 0 0 .232-.555.385.385 0 0 0-.153-.189.58.58 0 0 0-.287-.085l-.003-.014a.893.893 0 0 1-.058.012h-.035v.005c-.234.028-.36-.085-.393-.136a.297.297 0 0 1 .08-.395.258.258 0 0 1 .372.075l.112-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.063.1.248.24.548.193.13 0 .215.031.269.066.059.04.087.087.1.122Z"
        fill="#F9A33D"
      />
      <path
        d="m11.425 61.307-.087.044.078.182.088-.043-.079-.183ZM12.176 62.816l-.087.043.078.183.087-.044-.078-.182Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="m"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={1}
      y={56}
      width={4}
      height={6}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.814 60.544c.969-.48 1.404-1.688.974-2.695-.431-1.009-1.566-1.437-2.534-.957-.969.48-1.405 1.686-.974 2.695.193.45.526.786.923.975l.057.652a.13.13 0 0 0 .233.075l.456-.549a1.86 1.86 0 0 0 .865-.197Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#m)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.814 60.544c.969-.48 1.404-1.687.974-2.695-.431-1.009-1.566-1.437-2.534-.957-.969.48-1.405 1.686-.974 2.695.193.451.526.786.923.975l.057.652a.13.13 0 0 0 .233.075l.456-.549a1.86 1.86 0 0 0 .865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m2.203 60.562.133-.016-.007-.08-.068-.032-.058.128Zm.057.652-.134.017.134-.017Zm.233.075.1.091-.1-.09Zm.456-.549.1.092-.1-.092Zm0 0 .007-.141-.064-.002-.042.052.1.09Zm1.716-2.831c.401.938-.004 2.06-.905 2.507l.108.255c1.036-.514 1.503-1.805 1.042-2.883l-.245.12Zm-2.357-.89c.901-.447 1.957-.048 2.357.89l.245-.121c-.461-1.079-1.675-1.537-2.71-1.023l.108.254Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.254c-1.036.513-1.502 1.803-1.041 2.882l.244-.121Zm.859.908a1.762 1.762 0 0 1-.859-.908l-.244.121c.206.483.563.841.987 1.044l.116-.257Zm.132.764-.057-.652-.266.033.056.652.267-.033Zm0 0-.267.033c.022.244.31.337.466.15l-.2-.183Zm.457-.55-.457.55.2.182.456-.548-.2-.183Zm0 0 .2.184v-.001l-.2-.182Zm.91-.232c-.262.13-.537.188-.804.183l-.012.282c.308.006.624-.062.924-.21l-.108-.255Z"
        fill="#F9A33D"
      />
      <path
        d="M3.592 60.023c.692-.343 1.004-1.206.696-1.927-.308-.721-1.12-1.027-1.812-.684-.693.343-1.004 1.206-.696 1.927.308.721 1.12 1.027 1.812.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.424 58.93a.295.295 0 0 1-.154.37.26.26 0 0 1-.348-.152l-.125.054c.08.216.314.319.521.229a.442.442 0 0 0 .231-.555.385.385 0 0 0-.152-.188.58.58 0 0 0-.288-.086l-.002-.014a.906.906 0 0 1-.059.012h-.035v.006c-.234.028-.36-.085-.393-.137a.297.297 0 0 1 .08-.394.258.258 0 0 1 .372.074l.113-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.062.1.248.241.547.193.13.001.215.032.269.066.06.04.087.088.1.123Z"
        fill="#F9A33D"
      />
      <path
        d="m2.644 57.805-.088.043.078.183.088-.044-.078-.182ZM3.395 59.313l-.088.044.078.182.088-.043-.078-.183Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="n"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={15}
      y={7}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.018 11c.968-.48 1.404-1.686.973-2.694-.43-1.008-1.565-1.436-2.533-.956-.969.48-1.405 1.686-.974 2.694.193.451.526.786.923.976l.057.652a.13.13 0 0 0 .232.075l.457-.55c.289.006.584-.057.865-.196Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#n)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.018 11c.968-.48 1.404-1.686.973-2.694-.43-1.008-1.565-1.436-2.533-.956-.969.48-1.405 1.686-.974 2.694.193.451.526.786.923.976l.057.652a.13.13 0 0 0 .232.075l.457-.55c.289.006.584-.057.865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m16.407 11.02.133-.016-.007-.08-.068-.033-.058.129Zm.056.652-.133.016.134-.016Zm.233.075.1.091-.1-.091Zm.457-.55.1.092-.1-.091Zm0 0 .007-.14-.064-.002-.042.051.1.091Zm1.716-2.83c.401.938-.004 2.06-.905 2.507l.108.254c1.036-.513 1.503-1.804 1.042-2.882l-.245.12Zm-2.357-.89c.901-.447 1.956-.048 2.357.89l.245-.121c-.461-1.079-1.675-1.537-2.71-1.024l.108.255Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.255c-1.036.514-1.502 1.804-1.041 2.883l.244-.121Zm.859.907a1.761 1.761 0 0 1-.859-.907l-.244.12c.206.483.563.842.987 1.045l.116-.258Zm.132.764-.057-.651-.266.032.056.652.267-.033Zm0 0-.267.033c.022.245.31.338.466.15l-.2-.183Zm.457-.548-.457.548.199.183.457-.549-.2-.182Zm0 0 .199.182-.2-.183Zm.91-.233c-.262.13-.537.188-.804.182l-.012.282c.308.006.624-.06.924-.21l-.108-.254Z"
        fill="#F9A33D"
      />
      <path
        d="M17.796 10.48c.692-.342 1.004-1.205.696-1.926-.308-.721-1.12-1.028-1.812-.684-.693.343-1.005 1.206-.696 1.927.308.72 1.119 1.027 1.812.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.628 9.388a.295.295 0 0 1-.154.37.259.259 0 0 1-.348-.153l-.125.054c.08.217.314.32.521.23a.442.442 0 0 0 .231-.555.385.385 0 0 0-.152-.189.579.579 0 0 0-.288-.085l-.002-.015a.777.777 0 0 1-.059.013h-.035v.005c-.234.029-.36-.085-.393-.137a.296.296 0 0 1 .08-.393.258.258 0 0 1 .372.074l.113-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.062.1.247.24.547.193.13 0 .215.031.269.066a.25.25 0 0 1 .1.123Z"
        fill="#F9A33D"
      />
      <path
        d="m16.848 8.262-.088.044.078.182.088-.043-.078-.183ZM17.599 9.77l-.088.044.078.183.088-.044-.078-.182Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="o"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={13}
      y={13}
      width={5}
      height={6}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.392 17.524c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.437-2.533-.957-.97.48-1.405 1.687-.974 2.695.193.451.526.786.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.584-.057.865-.196Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#o)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.392 17.524c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.437-2.534-.957-.968.48-1.404 1.687-.973 2.695.193.451.526.786.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.583-.057.865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m14.78 17.543.134-.017-.007-.079-.068-.033-.058.129Zm.057.652-.133.016.133-.016Zm.233.075.1.091-.1-.091Zm.457-.55.1.092-.1-.091Zm0 0 .007-.14-.064-.002-.043.051.1.091Zm1.716-2.83c.4.938-.005 2.06-.906 2.507l.11.254c1.035-.513 1.501-1.804 1.04-2.883l-.244.122ZM14.886 14c.9-.447 1.956-.048 2.357.89l.245-.122c-.461-1.078-1.675-1.536-2.711-1.023l.109.255Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.255c-1.036.514-1.502 1.804-1.041 2.883l.244-.121Zm.859.907a1.76 1.76 0 0 1-.859-.907l-.245.12c.207.483.564.842.988 1.045l.116-.258Zm.132.764-.057-.652-.266.033.056.652.267-.033Zm0 0-.267.033c.021.245.31.338.466.15l-.2-.183Zm.457-.549-.457.55.199.182.457-.549-.2-.183Zm0 0 .199.183-.2-.183Zm.91-.232c-.262.13-.537.188-.805.182l-.011.282c.308.006.623-.06.924-.21l-.109-.254Z"
        fill="#F9A33D"
      />
      <path
        d="M16.17 17.004c.692-.343 1.004-1.206.696-1.927-.308-.721-1.12-1.028-1.812-.684-.693.343-1.005 1.206-.697 1.927.309.72 1.12 1.027 1.813.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.002 15.91a.295.295 0 0 1-.154.371.259.259 0 0 1-.348-.153l-.125.054c.08.217.313.32.52.23a.442.442 0 0 0 .232-.555.384.384 0 0 0-.152-.189.579.579 0 0 0-.288-.085l-.003-.015a.691.691 0 0 1-.058.013h-.035v.005c-.234.028-.36-.085-.393-.137a.296.296 0 0 1 .08-.393.258.258 0 0 1 .372.074l.112-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.063.1.248.24.548.193.13 0 .215.031.269.066a.25.25 0 0 1 .1.123Z"
        fill="#F9A33D"
      />
      <path
        d="m15.222 14.785-.088.044.078.182.088-.043-.078-.183ZM15.972 16.294l-.087.043.078.183.087-.044-.078-.182Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="p"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={18}
      y={12}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.596 16.123c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.437-2.534-.957-.968.48-1.404 1.687-.973 2.695.192.451.526.786.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.583-.057.865-.196Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#p)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.596 16.123c.968-.48 1.404-1.687.973-2.695-.43-1.008-1.565-1.437-2.534-.957-.968.48-1.404 1.687-.973 2.695.192.451.526.786.923.976l.056.652a.13.13 0 0 0 .233.075l.457-.55c.288.006.583-.057.865-.196Z"
        fill="#F2C94C"
      />
      <path
        d="m19.985 16.142.133-.017-.007-.079-.069-.033-.057.129Zm.056.652-.133.016.133-.016Zm.233.075.1.091-.1-.091Zm.457-.55.1.092-.1-.091Zm0 0 .006-.14-.063-.002-.043.051.1.091Zm1.716-2.83c.4.938-.005 2.06-.906 2.506l.109.255c1.036-.513 1.502-1.804 1.042-2.883l-.245.122Zm-2.357-.89c.9-.447 1.956-.048 2.357.89l.245-.122c-.461-1.078-1.675-1.536-2.711-1.023l.109.255Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.255c-1.036.514-1.502 1.804-1.042 2.883l.245-.121Zm.858.907a1.762 1.762 0 0 1-.858-.907l-.245.12c.207.483.564.842.988 1.044l.116-.257Zm.132.764-.056-.652-.267.033.057.652.266-.033Zm0 0-.266.033c.021.245.31.338.466.15l-.2-.183Zm.457-.549-.457.55.2.182.457-.549-.2-.183Zm0 0 .2.183-.2-.183Zm.91-.233c-.262.13-.536.189-.804.183l-.011.282c.308.006.623-.06.924-.21l-.109-.255Z"
        fill="#F9A33D"
      />
      <path
        d="M21.373 15.603c.693-.344 1.005-1.206.697-1.927-.308-.722-1.12-1.028-1.812-.684-.693.343-1.005 1.206-.697 1.927.308.72 1.12 1.027 1.812.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.206 14.51a.295.295 0 0 1-.154.37.259.259 0 0 1-.348-.153l-.125.054c.08.217.313.32.52.23a.442.442 0 0 0 .232-.555.384.384 0 0 0-.153-.189.579.579 0 0 0-.287-.085l-.003-.015a.747.747 0 0 1-.058.013h-.035v.005c-.234.028-.36-.085-.393-.137a.296.296 0 0 1 .08-.393.258.258 0 0 1 .372.074l.112-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.589c.063.1.248.24.548.193.13 0 .215.031.269.066a.25.25 0 0 1 .1.123Z"
        fill="#F9A33D"
      />
      <path
        d="m20.425 13.384-.087.044.078.182.087-.043-.078-.183ZM21.176 14.893l-.087.043.078.183.087-.044-.078-.182Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="q"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={10}
      y={8}
      width={4}
      height={6}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.814 12.62c.969-.48 1.405-1.686.974-2.695-.431-1.008-1.566-1.436-2.534-.956-.969.48-1.405 1.686-.974 2.695.193.45.527.786.923.975l.057.652a.13.13 0 0 0 .232.075l.457-.549c.289.005.584-.058.865-.197Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#q)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.814 12.62c.969-.48 1.405-1.686.974-2.695-.431-1.008-1.566-1.436-2.534-.956-.969.48-1.405 1.686-.974 2.695.193.45.527.786.923.975l.057.652a.13.13 0 0 0 .232.075l.457-.549c.289.005.584-.057.865-.197Z"
        fill="#F2C94C"
      />
      <path
        d="m11.203 12.64.133-.017-.007-.08-.068-.032-.058.128Zm.057.651-.134.016.134-.016Zm.232.075.1.091-.1-.091Zm.457-.549.1.091-.1-.09Zm0 0 .007-.141-.064-.002-.042.052.1.09Zm1.716-2.831c.401.938-.004 2.06-.905 2.507l.108.255c1.037-.514 1.503-1.805 1.042-2.883l-.245.121Zm-2.357-.89c.901-.446 1.957-.048 2.357.89l.245-.121c-.461-1.079-1.675-1.537-2.71-1.023l.108.254Zm-.906 2.507c-.4-.938.005-2.06.906-2.507l-.109-.254c-1.036.513-1.502 1.804-1.041 2.882l.244-.121Zm.859.908a1.761 1.761 0 0 1-.859-.908l-.244.121c.206.483.563.841.987 1.044l.116-.257Zm.132.764-.057-.652-.266.033.056.651.267-.032Zm0 0-.267.032c.022.245.31.338.466.15l-.2-.182Zm.457-.55-.457.55.2.182.456-.549-.2-.182Zm0 0 .2.183-.2-.182Zm.91-.232c-.262.13-.537.188-.804.183l-.012.281c.308.007.624-.06.924-.21l-.108-.254Z"
        fill="#F9A33D"
      />
      <path
        d="M12.592 12.1c.692-.343 1.004-1.206.696-1.927-.308-.721-1.12-1.027-1.812-.684-.693.343-1.004 1.206-.696 1.927.308.721 1.12 1.027 1.812.684Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.424 11.007a.295.295 0 0 1-.154.37.259.259 0 0 1-.348-.152l-.125.054c.08.216.314.319.521.229a.442.442 0 0 0 .231-.555.384.384 0 0 0-.152-.188.579.579 0 0 0-.287-.086l-.003-.014a.781.781 0 0 1-.059.012 1.4 1.4 0 0 0-.034 0v.005c-.235.029-.361-.084-.394-.136a.296.296 0 0 1 .08-.394.258.258 0 0 1 .372.074l.113-.08a.386.386 0 0 0-.557-.11.444.444 0 0 0-.12.59c.062.1.248.24.547.192.13.001.215.031.269.067a.25.25 0 0 1 .1.122Z"
        fill="#F9A33D"
      />
      <path
        d="m11.644 9.882-.088.043.078.183.088-.044-.078-.182ZM12.395 11.39l-.088.043.078.183.088-.043-.078-.183Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="r"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={43}
      y={51}
      width={23}
      height={25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.875 73.97c5.945-.944 10.069-6.789 9.21-13.053-.858-6.264-6.374-10.575-12.32-9.63-5.945.945-10.069 6.79-9.21 13.053.384 2.803 1.7 5.215 3.57 6.94l-.646 3.664c-.121.687.592 1.191 1.151.814l3.276-2.21.003-.002c1.55.53 3.24.7 4.966.425Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#r)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.875 73.97c5.945-.944 10.069-6.789 9.21-13.053-.858-6.264-6.374-10.575-12.32-9.63-5.945.945-10.069 6.79-9.21 13.053.384 2.803 1.7 5.215 3.57 6.94l-.646 3.664c-.121.687.592 1.191 1.151.814l3.276-2.21a.01.01 0 0 1 .003-.002c1.55.53 3.24.7 4.966.425Z"
        fill="#F2C94C"
      />
      <path
        d="m47.125 71.28.746.141.078-.447-.322-.298-.502.603Zm-.646 3.664-.746-.142.746.142Zm1.151.814.406.673-.406-.673Zm3.276-2.21.406.672-.405-.672Zm.003-.002.239-.76-.343-.118-.304.207.408.67Zm13.426-12.51c.799 5.828-3.038 11.265-8.568 12.144l.216 1.582c6.36-1.012 10.771-7.263 9.852-13.964l-1.5.239Zm-11.461-8.958c5.53-.88 10.662 3.131 11.46 8.959l1.501-.239c-.918-6.7-6.818-11.313-13.178-10.302l.217 1.582ZM44.304 64.22c-.799-5.827 3.038-11.264 8.569-12.143l-.218-1.582c-6.36 1.012-10.77 7.263-9.852 13.964l1.501-.239Zm3.322 6.455c-1.74-1.605-2.964-3.847-3.322-6.455l-1.5.239c.41 2.997 1.819 5.578 3.819 7.423l1.002-1.207Zm-.403 4.41.647-3.665-1.491-.283-.647 3.664 1.491.283Zm0 0-1.49-.284c-.243 1.375 1.183 2.384 2.302 1.629l-.812-1.346Zm3.277-2.211-3.277 2.21.812 1.346 3.276-2.21-.811-1.346Zm0 0 .812 1.345.003-.003h.001l-.816-1.342Zm5.266.305a9.567 9.567 0 0 1-4.62-.395l-.476 1.522a11 11 0 0 0 5.312.455l-.216-1.582Z"
        fill="#F9A33D"
      />
      <path
        d="M55.432 70.74c4.252-.676 7.201-4.855 6.587-9.335-.614-4.48-4.559-7.563-8.811-6.887-4.252.676-7.2 4.855-6.587 9.335.614 4.48 4.559 7.563 8.811 6.887Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.123 64.469c.078.884-.538 1.671-1.377 1.759-.838.088-1.58-.557-1.659-1.44l-.755.08c.117 1.322 1.23 2.288 2.485 2.156 1.255-.132 2.178-1.311 2.061-2.634a2.334 2.334 0 0 0-.549-1.295c-.309-.37-.767-.71-1.43-.967l.005-.083a4.088 4.088 0 0 1-.334-.033 6.899 6.899 0 0 0-.19-.056l-.006.024c-1.31-.25-1.83-1.09-1.93-1.43-.247-.847.205-1.75 1.01-2.015.804-.267 1.657.204 1.904 1.05l.726-.239c-.371-1.268-1.648-1.973-2.853-1.574-1.205.398-1.882 1.75-1.512 3.018.192.655.99 1.747 2.683 2.006.705.231 1.117.543 1.357.83.264.316.345.629.364.843Z"
        fill="#F9A33D"
      />
      <path
        d="m53.542 56.958-.538.086.156 1.134.538-.086-.156-1.134ZM55.403 66.513l-.538.085.154 1.135.539-.086-.155-1.134Z"
        fill="#F9A33D"
      />
    </g>
  </svg>
)

export default MatahariUang2
